import { cn } from '@/lib/utils';

interface StatProps {
  value: string;
  label: string;
  tone?: 'accent' | 'ink' | 'muted';
  className?: string;
}

/** A single figure with its label. Mono numerals, left-aligned, ruled on the left. */
export function Stat({ value, label, tone = 'ink', className }: StatProps) {
  return (
    <div className={cn('border-l border-line pl-4', className)}>
      <p
        className={cn(
          'font-mono text-2xl font-semibold tabular sm:text-3xl',
          tone === 'accent' && 'text-accent-ink',
          tone === 'ink' && 'text-ink',
          tone === 'muted' && 'text-ink-3'
        )}
      >
        {value}
      </p>
      <p className="mt-1.5 text-xs leading-relaxed text-ink-3 sm:text-[13px]">{label}</p>
    </div>
  );
}
